import BankDumps from "../../../jsx/components/Dashboard/BankDumps/BankDumps";

const BankDumpsWrapper = () => {
  return <BankDumps />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(BankDumpsWrapper);
